import { useState, useEffect, useCallback, useRef, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { setUserSubscription, selectUserData, selectUserSubscription, setSelectedSubscription, setSelectedFrequency, setSelectedOffset, setSelectedweekdayOffset, setSelectedTimeOffset, setSelectedFileFormat, setIsSubscriptionActive, setIsEditSubscription } from "../data/dataSlice"
import { usePbiGetSubscriptionsMutation, usePbiCreateSubscriptionsMutation, usePbiDeleteSubscriptionsMutation, usePbiEnableSubscriptionsMutation, usePbiDisableSubscriptionsMutation } from '../auth/authApiSlice'
import AddSubscription from '../../components/addsubscription'
import Spinner from '../../components/Spinner'
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import ConfirmationDialog from './ConfirmationDialog'


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: 'Subscription Name',
    },
    {
        id: 'reportName',
        numeric: false,
        disablePadding: false,
        label: 'Report Name',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'Subscribe To',
    },
    {
        id: 'frequencyUnit',
        numeric: false,
        disablePadding: false,
        label: 'Schedule',
    },
    {
        id: 'nextExecutionDate',
        numeric: false,
        disablePadding: false,
        label: 'Next Execution Date',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'Action',
        isSortHide: true
    },
];

const DEFAULT_ORDER = 'asc';
const DEFAULT_ORDER_BY = 'name';
const DEFAULT_ROWS_PER_PAGE = 15;
const label = { inputProps: { 'aria-label': 'Switch demo' } };

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, handleSearch, clearSearch,
        searchReportTxt, searchTxt, searchSubscriber } =
        props;
    const createSortHandler = (newOrderBy) => (event) => {
        onRequestSort(event, newOrderBy);
    };
    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all subscription',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (

                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            hideSortIcon={headCell.isSortHide ? headCell.isSortHide : false}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                        {headCell.id === 'name' || headCell.id === 'reportName' || headCell.id === 'actions' ?
                            <Box
                                display="flex"
                                borderRadius="3px"
                                className="searchSubsbox"
                            >
                                <InputBase sx={{ ml: 1, flex: 1 }} placeholder="Search"
                                    value={headCell.id === 'name' ? searchTxt : headCell.id === 'reportName' ? searchReportTxt : searchSubscriber}
                                    name={headCell.id === 'name' ? 'name' : headCell.id === 'reportName' ? 'report' : 'subscriber'}
                                    onChange={(e) => handleSearch(e, headCell.id === 'name' ? 'name' : headCell.id === 'reportName' ? 'report' : 'subscriber')} />
                                <IconButton type="button" sx={{ p: 1 }}>
                                    {(headCell.id === 'name' && searchTxt !== '') || (headCell.id === 'reportName' && searchReportTxt !== '') || (headCell.id === 'actions' && searchSubscriber !== '') ?
                                        <CloseIcon onClick={() => clearSearch(headCell.id === 'name' ? 'name' : headCell.id === 'reportName' ? 'report' : 'subscriber')} /> :
                                        <SearchIcon />}
                                </IconButton>
                            </Box> : null
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    handleSearch: PropTypes.func.isRequired,
    clearSearch: PropTypes.func.isRequired,
    searchTxt: PropTypes.string.isRequired,
    searchReportTxt: PropTypes.string.isRequired,
    searchSubscriber: PropTypes.string.isRequired

};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;
    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    My Subscription
                </Typography>
            )}

            {/* {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton>
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )} */}
        </Toolbar>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const UserSubscription = () => {
    const [order, setOrder] = useState(DEFAULT_ORDER);
    const [orderBy, setOrderBy] = useState(DEFAULT_ORDER_BY);
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(false);
    const [visibleRows, setVisibleRows] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const errRef = useRef()
    const [errMsg, setErrMsg] = useState('')
    const dispatch = useDispatch()
    const [searchTxt, setSearchTxt] = useState('')
    const [searchReportTxt, setSearchReportTxt] = useState('')
    const [searchSubscriber, setSearchSubscriber] = useState('')

    const [spinnerLoad, setSpinnerLoad] = useState(false)
    const [openConfirmation, setOpenConfirmation] = useState(false)

    const [openAddSubscription, setOpenAddSubscription] = useState(false);

    const [pbiSubscriptionList, { ispbiSubscriptionListLoading }] = usePbiGetSubscriptionsMutation()
    const [pbiDeleteSubscription, { ispbiDeleteSubscriptionLoading }] = usePbiDeleteSubscriptionsMutation()
    const [pbiEnableSubscription, { ispbiEnableSubscriptionLoading }] = usePbiEnableSubscriptionsMutation()
    const [pbiDisableSubscription, { ispbiDisableSubscriptionLoading }] = usePbiDisableSubscriptionsMutation()

    const userSubscriptionData = useSelector(selectUserSubscription)
    const rows = userSubscriptionData ? userSubscriptionData : []
    useEffect(() => {
        setVisibleRows(userSubscriptionData);
    }, [userSubscriptionData])

    const handleOpenAddSubscription = (e, rowid) => {
        e.preventDefault();
        dispatch(setIsEditSubscription(true))
        const selectedSubscriptionRow = rows.find(x => x.id === rowid)
        const offsetvalue = Math.floor(selectedSubscriptionRow.offset / 1440) * 1440;
        const offsettime = selectedSubscriptionRow.offset % 1440;
        // const weekdayOffvalue = (offsetvalue - 1440);
        const isSubscriptionStatus = selectedSubscriptionRow.active == "true" ? true : false
        dispatch(setSelectedSubscription(selectedSubscriptionRow))
        dispatch(setSelectedFrequency(selectedSubscriptionRow.frequencyUnit))
        dispatch(setSelectedOffset(offsetvalue))
        dispatch(setSelectedweekdayOffset(offsetvalue))
        dispatch(setSelectedTimeOffset(offsettime))
        dispatch(setSelectedFileFormat(selectedSubscriptionRow.fileFormat))
        dispatch(setIsSubscriptionActive(isSubscriptionStatus))
        setOpenAddSubscription(true);
    }

    const handleDeleteSubscription = async () => {
        try {
            setSpinnerLoad(true)
            // const rowiddetails = { id: rowid.id }
            const rowiddetails = { "ids": selected }
            await pbiDeleteSubscription(rowiddetails);
            handleConfirmationClose()
            handleGetAllSubscripion();
            setSelected([])
            setSpinnerLoad(false)
        } catch (err) {
            if (!err?.originalStatus) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            // errRef.current.focus();
            setSpinnerLoad(false)
        }
    }

    const handleEnableSubscription = async (rowid) => {
        try {
            setSpinnerLoad(true)
            const rowiddetails = { id: rowid }
            const getSubscriptionList = await pbiEnableSubscription(rowiddetails);
            setSpinnerLoad(false)
            handleGetAllSubscripion()
        } catch (err) {
            if (!err?.originalStatus) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            // errRef.current.focus();
            setSpinnerLoad(false)
        }
    }

    const handleDisableSubscription = async (rowid) => {
        try {
            setSpinnerLoad(true)
            const rowiddetails = { id: rowid }
            const getSubscriptionList = await pbiDisableSubscription(rowiddetails);
            setSpinnerLoad(false)
            handleGetAllSubscripion()
        } catch (err) {
            if (!err?.originalStatus) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            setSpinnerLoad(false)
        }
    }

    const handleGetAllSubscripion = async () => {
        try {
            const logindetails = { "loginId": userdata.userName }
            setSpinnerLoad(true)
            const getSubscriptionList = await pbiSubscriptionList(logindetails).unwrap()
            if (getSubscriptionList && getSubscriptionList.subscriptions) {
                dispatch(setUserSubscription(getSubscriptionList.subscriptions))
                setSpinnerLoad(false)
            } else {
                dispatch(setUserSubscription([]))
                setSpinnerLoad(false)
            }
        } catch (err) {
            if (!err?.originalStatus) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            // errRef.current.focus();
            setSpinnerLoad(false)
        }
    }

    const handleAddSubscriptionClose = () => {
        setOpenAddSubscription(false);
        dispatch(setIsEditSubscription(false))
    }

    const userdata = useSelector(selectUserData)

    useEffect(() => {
        try {
            handleGetAllSubscripion();
        } catch (err) {
            if (!err?.originalStatus) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            // errRef.current.focus();
        }
    }, [])

    useEffect(() => {
        let rowsOnMount = stableSort(
            rows,
            getComparator(DEFAULT_ORDER, DEFAULT_ORDER_BY),
        );

        rowsOnMount = rowsOnMount.slice(
            0 * DEFAULT_ROWS_PER_PAGE,
            0 * DEFAULT_ROWS_PER_PAGE + DEFAULT_ROWS_PER_PAGE,
        );

        setVisibleRows(rowsOnMount);
    }, [userSubscriptionData]);

    const handleRequestSort = useCallback(
        (event, newOrderBy) => {
            const isAsc = orderBy === newOrderBy && order === 'asc';
            const toggledOrder = isAsc ? 'desc' : 'asc';
            setOrder(toggledOrder);
            setOrderBy(newOrderBy);

            const sortedRows = stableSort(rows, getComparator(toggledOrder, newOrderBy));
            const updatedRows = sortedRows.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            );
            setVisibleRows(updatedRows);
        },
        [order, orderBy, page, rowsPerPage],
    );

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else {
            if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }
        }

        setSelected(newSelected);
    };

    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage);

            const sortedRows = stableSort(rows, getComparator(order, orderBy));
            const updatedRows = sortedRows.slice(
                newPage * rowsPerPage,
                newPage * rowsPerPage + rowsPerPage,
            );

            setVisibleRows(updatedRows);

            // Avoid a layout jump when reaching the last page with empty rows.
            const numEmptyRows =
                newPage > 0 ? Math.max(0, (1 + newPage) * rowsPerPage - rows.length) : 0;

            const newPaddingHeight = (dense ? 33 : 53) * numEmptyRows;
            setPaddingHeight(newPaddingHeight);
        },
        [order, orderBy, dense, rowsPerPage],
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);

            setPage(0);

            const sortedRows = stableSort(rows, getComparator(order, orderBy));
            const updatedRows = sortedRows.slice(
                0 * updatedRowsPerPage,
                0 * updatedRowsPerPage + updatedRowsPerPage,
            );

            setVisibleRows(updatedRows);

            // There is no layout jump to handle on the first page.
            setPaddingHeight(0);
        },
        [order, orderBy],
    );

    const handleEnableDisableSubscription = (event, rowid) => {
        if (event.target.checked) {
            handleEnableSubscription(rowid);
        } else {
            handleDisableSubscription(rowid);
        }
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;


    const convertSheduleOffset = (value) => {
        if (value == "weeks") {
            return "Weekly"
        } else if (value == "months") {
            return "Monthly"
        } else {
            return "Daily"
        }
    }


    const handleSearchChange = (e, name) => {
        if (name === 'name') {
            setSearchTxt(e.target.value)
        } else if (name === 'report') {
            setSearchReportTxt(e.target.value)
        } else if (name === 'subscriber') {
            setSearchSubscriber(e.target.value)
        }
    }

    const handleSearchClear = (name) => {
        if (name === 'name') {
            setSearchTxt('')
        }
        if (name === 'report') {
            setSearchReportTxt('')
        }
        if (name === 'subscriber') {
            setSearchSubscriber('')
        }
    }

    useEffect(() => {
        if(searchTxt === '' && searchReportTxt === '' && searchSubscriber === '') {
            handleChangeRowsPerPage({target: {value: DEFAULT_ROWS_PER_PAGE}})
        }
    }, [searchTxt, searchReportTxt, searchSubscriber])

    useEffect(() => {
        if((searchTxt !== '' && searchTxt.length >= 3) || (searchReportTxt !== '' && searchReportTxt.length >= 3) || (searchSubscriber !== '' && searchSubscriber.length >= 3)) {
            let filteredData = userSubscriptionData;
        if (searchTxt !== '' && searchTxt.length >= 3) {
            const searchValue = searchTxt;
            filteredData = filteredData.filter((row) => {
                return row.name && row.name !== null && row.name.toLowerCase().includes(searchValue.toLowerCase());
            })
        }
        if (searchReportTxt !== '' && searchReportTxt.length >= 3) {
            const searchValue = searchReportTxt;
            filteredData = filteredData.filter((row) => {
                return row.reportName && row.reportName !== null && row.reportName.toLowerCase().includes(searchValue.toLowerCase());
            })
        }
        if (searchSubscriber !== '' && searchSubscriber.length >= 3) {
            const searchValue = searchSubscriber;
            filteredData = filteredData.filter((row) => {
                return row.actions && row.actions.length && row.actions[0].toLowerCase().includes(searchValue.toLowerCase());
            })
        }
        setVisibleRows(filteredData);
    }
    }, [searchTxt, searchReportTxt, searchSubscriber, userSubscriptionData]) 

    const renderSubscription = (actions) => {
        try {
            let subscriptionObj = JSON.parse(actions[0].replace("mailto:", ""));
            let receiver = subscriptionObj.receiver ? subscriptionObj.receiver.join(", ") : "";
            let CCData = subscriptionObj.cc ? subscriptionObj.cc.join(", ") : "";
            let BccData = subscriptionObj.bcc ? subscriptionObj.bcc.join(", ") : "";
            return `${receiver}, cc: ${CCData}, bcc: ${BccData}`
        } catch (e) {
            return actions[0]
        }
    }

    const handleConfirmationClose = () => {
        setOpenConfirmation(false)
        setSelected([]);
    }

    const formatDate = (dateString) => {
        // Create a Date object from the given dateString
        const date = new Date(dateString);
        let formattedDate = date.toUTCString();
        formattedDate = formattedDate.toString().replace('GMT', 'UTC');
        return formattedDate;
    }

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2 }}>
                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer className="divsubcriptiondata">
                        <Table
                            sx={{ minWidth: 750 }}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                            stickyHeader={true}
                        >
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                                handleSearch={(e, name) => handleSearchChange(e, name)}
                                clearSearch={(name) => handleSearchClear(name)}
                                searchReportTxt={searchReportTxt}
                                searchTxt={searchTxt}
                                searchSubscriber={searchSubscriber}
                            />
                            <TableBody>
                                {visibleRows && visibleRows.length ? //visibleRows && visibleRows.length ?
                                    visibleRows.map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                onClick={(event) => handleClick(event, row.id)}
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={isItemSelected}
                                                sx={{ cursor: 'pointer' }}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        color="primary"
                                                        checked={isItemSelected}
                                                        inputProps={{
                                                            'aria-labelledby': labelId,
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                    size='medium'
                                                >
                                                    {row.name ? row.name : null}
                                                </TableCell>
                                                <TableCell align="left" size='medium'>{row.reportName ? row.reportName : null}</TableCell>
                                                <TableCell align="left" size='small'>{row.actions && row.actions.length ? renderSubscription(row.actions) : ""}</TableCell>
                                                <TableCell align="left" size='small'>{convertSheduleOffset(row.frequencyUnit)}</TableCell>
                                                <TableCell align="left" size='small'>{row.nextExecutionDate === 'null' ? row.nextExecutionDate : formatDate(row.nextExecutionDate)}</TableCell>
                                                <TableCell align="left" size='small'>
                                                    <div className="actionSwitchdiv">
                                                        <IconButton onClick={(e) => handleOpenAddSubscription(e, row.id)}>
                                                            <DriveFileRenameOutlineIcon />
                                                        </IconButton>
                                                        {/* <IconButton onClick={() => handleDeleteSubscription(row.id)}>
                                                            <DeleteIcon />
                                                        </IconButton> */}
                                                        <Stack direction="row" alignItems="center">
                                                            <Typography>Off</Typography>
                                                            <Switch {...label} onChange={(e) => handleEnableDisableSubscription(e, row.id)} checked={row.active && row.active == "true" ? true : false} color="secondary" />
                                                            <Typography>On</Typography>
                                                        </Stack>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                    : null}
                                {paddingHeight > 0 && (
                                    <TableRow
                                        style={{
                                            height: paddingHeight,
                                        }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 10px', margin: '0 10px' }}>
                        <TablePagination
                            rowsPerPageOptions={[15, 25, 35]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                        <IconButton

                            // onClick={() => handleDeleteSubscription()}
                            onClick={() => setOpenConfirmation(true)}
                            disabled={selected.length === 0}
                            variant="contained"
                            style={{ color: selected.length > 0 && '#FFF', backgroundColor: selected.length === 0 ? '#e4e4e4' : 'rgb(0, 99, 204)', margin: '5px', padding: '10px' }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                </Paper>
                {/* <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
          /> */}
            </Box>
            {openConfirmation && (<ConfirmationDialog open={openConfirmation} handleDeleteSubscription={handleDeleteSubscription} onClose={handleConfirmationClose} selected={selected} />)}
            <AddSubscription openAddSubscription={openAddSubscription} handleAddSubscriptionClose={handleAddSubscriptionClose} />
            {spinnerLoad && (<Spinner />)}
        </>
    );
}
export default UserSubscription